import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { ExtendedLocation } from '../../../ExtendedLocation.model';
import USCLogoWhite from '~/Assets/Images/USC/UrbanSportsClub_Logo_Combo_White.png';
import UrbanSportsClub_Logo_Unicorn_Black from '~/Assets/Images/USC/UrbanSportsClub_Logo_Unicorn_Black.png';
import { useTranslation } from 'react-i18next';

export const QRCodePdfFilePreview = ({
  extendedLocation,
  language,
}: {
  extendedLocation: ExtendedLocation;
  language: string;
}) => {
  const CANVAS_SIZE = 80;
  const { t } = useTranslation();
  return (
    <div
      id="divToPrint"
      style={{
        backgroundColor: 'white',
        width: '70mm',
        minHeight: '99mm',
        marginLeft: 'auto',
        marginRight: 'auto',
        color: 'black',
        position: 'relative',
        fontFamily: 'Apercu',
      }}
    >
      <div
        style={{
          width: '4.36mm',
          background: '#FFE98B',
          position: 'absolute',
          top: '0',
          height: '25.6mm',
        }}
      />
      <img
        style={{
          position: 'absolute',
          left: '41.01mm',
          top: '6.25mm',
          width: '24.15mm',
        }}
        src={USCLogoWhite}
      />
      <div
        style={{
          width: '4.36mm',
          background: '#FFD421',
          position: 'absolute',
          top: '25.56mm',
          height: '43.5mm',
        }}
      />
      <div
        style={{
          width: '4.36mm',
          background: '#68bba2',
          position: 'absolute',
          top: '59mm',
          height: '10mm',
        }}
      />
      <div
        style={{
          width: '4.36mm',
          background: '#A1E4F4',
          position: 'absolute',
          top: '69mm',
          height: '30.31mm',
        }}
      />

      <div
        style={{
          height: '59mm',
          background: '#031424',
          color: 'white',
          display: 'flex',
          alignItems: 'flex-end',
          paddingLeft: '8mm',
          paddingRight: '8.9mm',
          paddingBottom: '3mm',
          lineHeight: '6mm',
          fontSize: '6mm',
          whiteSpace: 'pre-line',
          letterSpacing: '-0.0023mm',
          fontFamily: 'Apercu',
          fontWeight: 700,
        }}
      >
        {t('flyer.sayHello', { lng: language.toLocaleLowerCase() })}
      </div>
      <div
        style={{
          height: '10mm',
          background: '#0a6c4f',
          color: 'white',
          display: 'flex',
          alignItems: 'flex-start',
          paddingLeft: '8mm',
          fontSize: '1.7mm',
          lineHeight: '2.8mm',
          whiteSpace: 'pre-line',
          letterSpacing: '-0.0023mm',
          fontFamily: 'Apercu',
          fontWeight: 700,
        }}
      >
        <p>
          {`${t('flyer.refer.description', { lng: language.toLocaleLowerCase() })} `}
          <span style={{ textDecoration: 'underline' }}>
            {t('flyer.refer.referalLink', { lng: language.toLocaleLowerCase() })}
          </span>
        </p>
      </div>
      <div
        style={{
          paddingLeft: '8mm',
          paddingTop: '3.33mm',
        }}
      >
        <div
          style={{
            marginLeft: '-2.8mm',
            marginTop: '-2.8mm',
          }}
        >
          <QRCodeSVG
            id="qrcode-element"
            fgColor={'#000000'}
            size={CANVAS_SIZE}
            value={extendedLocation.checkInUrl || ''}
            imageSettings={{
              src: UrbanSportsClub_Logo_Unicorn_Black,
              excavate: true,
              width: 12,
              height: 12,
            }}
            level="H"
            includeMargin
          />
        </div>
        <div
          style={{
            fontSize: '1.92mm',
            lineHeight: '2.3mm',
            fontWeight: 700,
            marginTop: '-1.47mm',
            paddingBottom: '1.47mm',
            letterSpacing: '-0.0023mm',
            fontFamily: 'Apercu',
          }}
        >
          {extendedLocation?.name}
        </div>
        {!!extendedLocation?.organisationVenueId?.toString() && (
          <div
            style={{
              fontSize: '1.7mm',
              lineHeight: '2.3mm',
              fontWeight: 500,
              marginTop: '-0.8mm',
              paddingBottom: '1.47mm',
              letterSpacing: '-0.0023mm',
              fontFamily: 'Apercu',
            }}
          >
            {t('flyer.venueId', { venueId: extendedLocation?.organisationVenueId })}
          </div>
        )}
        {!!extendedLocation?.venueAddressId && (
          <div
            style={{
              fontSize: '1.7mm',
              lineHeight: '2.3mm',
              fontWeight: 500,
              marginTop: '-1.47mm',
              paddingBottom: '1.47mm',
              letterSpacing: '-0.0023mm',
              fontFamily: 'Apercu',
            }}
          >
            {t('flyer.locationId', { locationId: extendedLocation?.venueAddressId })}
          </div>
        )}
      </div>
    </div>
  );
};
